import { render, staticRenderFns } from "./dialog-component.vue?vue&type=template&id=c8610a14&scoped=true&"
import script from "./dialog-component.vue?vue&type=script&lang=js&"
export * from "./dialog-component.vue?vue&type=script&lang=js&"
import style0 from "./dialog-component.vue?vue&type=style&index=0&id=c8610a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8610a14",
  null
  
)

export default component.exports